import {path} from '../lib/routes'
import {getModelPath} from './assets-config'
import {wordpressAPI} from '../lib/wordpress-api'

// Helper per navigare verso esperienze 3D con parametri personalizzati
export const navigateTo3DExperience = (history, location, config) => {
  const {
    modelType = 'generic',
    modelPath,
    scale = '1 1 1',
    position = '0 0 0',
    rotation = '0 0 0',
    title,
    description,
    envmap,
    animation = 'no',
    repeat = 'no',
    listAnim = ['Scene'],
    text = 'Animazione',
    customParams = {}
  } = config

  // Prepara i parametri personalizzati
  const finalCustomParams = {
    modelPath: modelPath || getModelPath(modelType),
    scale,
    position,
    rotation,
    animation,
    repeat,
    listAnim: JSON.stringify(listAnim),
    text,
    ...customParams
  }
  
  // Aggiungi envmap se specificato
  if (envmap && Array.isArray(envmap)) {
    finalCustomParams.envmap = JSON.stringify(envmap)
  }

  // Naviga verso l'esperienza universale
  const navState = {
    modelType,
    customParams: finalCustomParams,
    showScene: true,
    title,
    description,
  }

  // Debug ad alta densità per errori runtime in produzione (TDZ/minify)
  try {
    console.groupCollapsed(`🧭 navigateTo3DExperience → ${modelType}`)
    console.log('location.pathname:', location?.pathname)
    console.log('modelType:', modelType)
    console.log('title:', title)
    console.log('description:', description)
    console.log('finalCustomParams keys:', Object.keys(finalCustomParams || {}))
    console.log('finalCustomParams:', finalCustomParams)
    console.log('navState:', navState)
    console.groupEnd()
  } catch (e) {
    console.warn('⚠️ navigateTo3DExperience: log failed', e)
  }

  try {
    history.push(path(location, '3d-experience'), navState)
  } catch (e) {
    console.error('🧨 navigateTo3DExperience: history.push failed', e, {navState})
    throw e
  }
}

// Configurazioni predefinite per esperienze comuni
export const experienceConfigs = {
  castelOggi: {
    experienceType: '3d',
    modelType: 'castelOggi',
    title: 'Castel Oggi',
    description: 'Modello 3D del Castel Oggi con animazioni e interazioni.',
    scale: '0.7 0.7 0.7',
    position: '0 0 -15',
    rotation: '0 90 0',
    animation: 'no',
    repeat: 'yes',
    listAnim: ['Scene', 'hiphop', 'chicken'],
    text: 'Avvia Animazione'
  },
  castelIeri: {
    experienceType: '3d',
    modelType: 'castelIeri',
    title: 'Castel Ieri',
    description: 'Modello 3D del Castel Ieri con animazioni e interazioni.',
    scale: '5 5 5',
    position: '0 0 -15',
    rotation: '0 0 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Animation'],
    text: 'Fai volare le Aquile'
  },
  palladicannone: {
    experienceType: '3d',
    modelType: 'palladicannone',
    title: 'Palladi Cannone',
    description: 'Modello 3D della Palladi Cannone con animazioni e interazioni.',
    scale: '5 5 5',
    position: '0 0 -15',
    rotation: '0 0 0',
    animation: 'yes',
    repeat: 'no',
    listAnim: ['SphereAction'],
    text: 'Fai uscire la palla di cannone'
  },
  carrosuponte: {
    experienceType: '3d',
    modelType: 'carrosuponte',
    title: 'Carro su Ponte',
    description: 'Modello 3D del Carro su Ponte con animazioni e interazioni.',
    scale: '8 8 8',
    position: '0 0 -7',
    rotation: '0 0 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Animation'],
    text: 'Attraversa il ponte con i cavalli'
  },

  metaldetector: {
    experienceType: '3d',
    modelType: 'tutaAmianto',
    title: 'Metal Detector',
    description: 'Modello 3D del Metal Detector con animazioni e interazioni.',
    scale: '2.5 2.5 2.5',
    position: '0 0 0',
    rotation: '0 0 0',
    animation: 'no',
    repeat: 'yes',
    listAnim: ['Animation'],
    text: 'Fai funzionare il Metal Detector'
  },

  minatorechetrapano: {
    experienceType: '3d',
    modelType: 'minatorechetrapano',
    title: 'Minatore che trapana',
    description: 'Modello 3D del Minatore che trapana con animazioni e interazioni.',
    scale: '5 5 5',
    position: '2 0 -5',
    rotation: '0 0 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Action'],
    text: 'Fai trapanare il Minatore'
  },

  idroscivolante: {
    experienceType: '3d',
    modelType: 'idroscivolante',
    title: 'Idroscivolante',
    description: 'Modello 3D dell\'idroscivolante con animazioni e interazioni.',
    scale: '1.5 1.5 1.5',
    position: '0 0 -10',
    rotation: '0 -90 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Scene'],
    text: 'Scopri come funzionava'
  },
  tutaAmianto: {
    experienceType: '3d',
    modelType: 'tutaAmianto',
    title: 'Tuta Amianto',
    description: 'Modello 3D della tuta amianto con controlli di movimento.',
    scale: '3.5 3.5 3.5',
    animation: 'no',
    repeat: 'yes',
    listAnim: ['Scene', 'walk'],
    text: 'Cambia Animazione'
  },
  forno: {
    experienceType: '3d',
    modelType: 'forno',
    title: 'Forno',
    description: 'Modello 3D del Forno con animazioni e interazioni.',
    scale: '10 10 10',
    position: '0 0 -10',
    rotation: '0 0 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Animation'],
    text: 'Accendi il forno'
  },
  bunker: {
    experienceType: '3d',
    modelType: 'bunker',
    title: 'Bunker',
    description: 'Modello 3D del Bunker con animazioni e interazioni.',
    scale: '5 5 5',
    position: '2 0 -5',
    rotation: '0 30 0',
    animation: 'yes',
    repeat: 'no',
    listAnim: ['Animation'],
    text: 'Spara'
  },
  bleirot: {
    experienceType: '3d',
    modelType: 'bleirot',
    title: 'Bleirot',
    description: 'Modello 3D del Bleirot con animazioni e interazioni.',
    scale: '3 3 3',
    position: '0 -5 -5',
    rotation: '0 0 0',
    animation: 'yes',
    repeat: 'no',
    listAnim: ['Scene'],
    text: 'Decolla'
  },
  casteldelmonte: {
    experienceType: '3d',
    modelType: 'casteldelmonte',
    title: 'Castel del Monte',
    description: 'Modello 3D del Castel del Monte con animazioni e interazioni.',
    scale: '0.5 0.5 0.5',
    position: '0 0 0',
    rotation: '0 0 0',
    animation: 'no',
    repeat: 'yes',
    listAnim: ['Scene', 'rotate', 'scale'],
    text: 'Animazioni'
  },
  mitragliatrice: {
    experienceType: '3d',
    modelType: 'mitragliatrice',
    title: 'Mitragliatrice',
    description: 'Modello 3D della Mitragliatrice con animazioni e interazioni.',
    scale: '10 10 10',
    position: '2 0 -5',
    rotation: '0 0 0',
    animation: 'yes',
    repeat: 'no',
    listAnim: ['Animation'],
    text: 'Spara'
  },
  mongolfiera: {
    experienceType: '3d',
    modelType: 'mongolfiera',
    title: 'Mongolfiera',
    description: 'Modello 3D della Mongolfiera con animazioni e interazioni.',
    scale: '5 5 5',
    position: '2 0 -5',
    rotation: '0 30 0',
    envmap: [
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/px.png',
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/nx.png',
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/py.png',
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/ny.png',
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/pz.png',
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/nz.png'
    ],
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Scene', 'float', 'inflate'],
    text: 'Volo'
  },
  nuraghe: {
    experienceType: '3d',
    modelType: 'nuraghe',
    title: 'Nuraghe',
    description: 'Modello 3D del Nuraghe con animazioni e interazioni.',
    scale: '5 5 5',
    position: '-2 0 -5',
    rotation: '0 -30 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Animation'],
    text: 'Scopri l\'interno',
    modelPath: getModelPath('nuraghe'),
    customParams: {
      modelPath: getModelPath('nuraghe')
    }
  },
 
  radiomarconi: {
    experienceType: '3d',
    modelType: 'radiomarconi',
    title: 'Radio Marconi',
    description: 'Modello 3D della Radio Marconi con animazioni e interazioni.',
    scale: '5 5 5',
    position: '2 0 -5',
    rotation: '0 30 0',
    envmap: [
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/px.png',
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/nx.png',
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/py.png',
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/ny.png',
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/pz.png',
      'https://iscag-ei.it/wp-content/materiale/animazioni-3d/envmapradiomarconi/nz.png'
    ],
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Scene', 'transmit', 'receive'],
    text: 'Trasmissione'
  },
  statuatrapano: {
    experienceType: '3d',
    modelType: 'statuatrapano',
    title: 'Statua Trapano',
    description: 'Modello 3D della Statua Trapano con animazioni e interazioni.',
    scale: '5 5 5',
    position: '2 0 -5',
    rotation: '0 30 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Scene', 'drill', 'rotate'],
    text: 'Trapano'
  },
  stazioneradio: {
    experienceType: '3d',
    modelType: 'stazioneradio',
    title: 'Stazione Radio',
    description: 'Modello 3D della Stazione Radio con animazioni e interazioni.',
    scale: '5 5 5',
    position: '2 0 -5',
    rotation: '0 30 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Scene', 'broadcast', 'scan'],
    text: 'Broadcast'
  },
  stemmaricostruire: {
    experienceType: '3d',
    modelType: 'stemmaricostruire',
    title: 'Stemma Ricostruire',
    description: 'Modello 3D dello Stemma Ricostruire con animazioni e interazioni.',
    scale: '0 0 -5',
    position: '10 10 10',
    rotation: '0 0 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Animation'],
    text: 'Ricostruisci lo stemma'
  },
  teleferica: {
    experienceType: '3d',
    modelType: 'teleferica',
    title: 'Teleferica',
    description: 'Modello 3D della Teleferica con animazioni e interazioni.',
    scale: '5 5 5',
    position: '2 0 -5',
    rotation: '0 30 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Scene', 'move', 'stop'],
    text: 'Movimento'
  },
  vscalegnobarca: {
    experienceType: '3d',
    modelType: 'vscalegnobarca',
    title: 'V Scala Gno Barca',
    description: 'Modello 3D della V Scala Gno Barca con animazioni e interazioni.',
    scale: '5 5 5',
    position: '2 0 -5',
    rotation: '0 30 0',
    animation: 'yes',
    repeat: 'yes',
    listAnim: ['Animation'],
    text: 'Fai entrare la nave'
  },

  

  // Nuova esperienza: Ologramma Milone (Aerofono) via template "ologramma"
  ologrammaMilone: {
    experienceType: '3d',
    modelType: 'ologramma',
    title: 'Ologramma Milone - Aerofono',
    description: "Esperienza video ologramma con chroma key dell'Aerofono (Milone).",
    scale: '14 14 14',
    position: '0 0 -8',
    rotation: '0 0 0',
    // Parametri template-specific
    customParams: {
      videoName: 'olo-milone-aerofono',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    }
  },

  // Nuove esperienze ologramma Milone
  oloMiloneBleirot: {
    experienceType: '3d',
    modelType: 'ologramma',
    title: 'Ologramma Milone - Bleirot',
    description: "Esperienza video ologramma con chroma key del Bleirot (Milone).",
    scale: '14 14 14',
    position: '0 0 -8',
    rotation: '0 0 0',
    customParams: {
      videoName: 'olo-milone-bleirot',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    }
  },

  oloMiloneCastrum: {
    experienceType: '3d',
    modelType: 'ologramma',
    title: 'Ologramma Milone - Castrum',
    description: "Esperienza video ologramma con chroma key del Castrum (Milone).",
    scale: '14 14 14',
    position: '0 0 -8',
    rotation: '0 0 0',
    customParams: {
      videoName: 'olo-milone-castrum',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    }
  },

  oloMiloneOssidionali: {
    experienceType: '3d',
    modelType: 'ologramma',
    title: 'Ologramma Milone - Ossidionali',
    description: "Esperienza video ologramma con chroma key degli Ossidionali (Milone).",
    scale: '14 14 14',
    position: '0 0 -8',
    rotation: '0 0 0',
    customParams: {
      videoName: 'olo-milone-ossidionali',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    }
  },

  oloMilonePiccioni: {
    experienceType: '3d',
    modelType: 'ologramma',
    title: 'Ologramma Milone - Piccioni',
    description: "Esperienza video ologramma con chroma key dei Piccioni (Milone).",
    scale: '14 14 14',
    position: '0 0 -8',
    rotation: '0 0 0',
    customParams: {
      videoName: 'olo-milone-piccioni',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    }
  },

  oloMiloneStoriaIstituto: {
    experienceType: '3d',
    modelType: 'ologramma',
    title: 'Ologramma Milone - Storia Istituto',
    description: "Esperienza video ologramma con chroma key della Storia dell'Istituto (Milone).",
    scale: '14 14 14',
    position: '0 0 -8',
    rotation: '0 0 0',
    customParams: {
      videoName: 'olo-milone-storia-istituto',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    }
  },

  oloMiloneTelefonobell: {
    experienceType: '3d',
    modelType: 'ologramma',
    title: 'Ologramma Milone - Telefono Bell',
    description: "Esperienza video ologramma con chroma key del Telefono Bell (Milone).",
    scale: '14 14 14',
    position: '0 0 -8',
    rotation: '0 0 0',
    customParams: {
      videoName: 'olo-milone-telefonobell',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    }
  },

  oloMiloneTelegrafia: {
    experienceType: '3d',
    modelType: 'ologramma',
    title: 'Ologramma Milone - Telegrafia',
    description: "Esperienza video ologramma con chroma key della Telegrafia (Milone).",
    scale: '14 14 14',
    position: '0 0 -8',
    rotation: '0 0 0',
    customParams: {
      videoName: 'olo-milone-telegrafia',
      cameraPosition: '0 4 6',
      chromaColor: '0.02 0.08 0.99',
      groundSize: '1000 1000',
      riseHeight: '0.915',
      autoplay: 'false',
      loop: 'false'
    }
  },

  // Template per nuovi modelli
  createCustom: (modelName, options = {}) => ({
    experienceType: '3d',
    modelType: 'generic',
    modelPath: getModelPath(modelName),
    title: options.title || modelName,
    description: options.description || `Modello 3D di ${modelName}`,
    scale: options.scale || '1 1 1',
    position: options.position || '0 0 0',
    rotation: options.rotation || '0 0 0',
    envmap: options.envmap || null,
    animation: options.animation || 'no',
    repeat: options.repeat || 'no',
    listAnim: options.listAnim || ['Scene'],
    text: options.text || 'Animazione',
    ...options
  }),

  // NUOVE CONFIGURAZIONI PER OLOGRAmmi
  hologramCastelOggi: {
    experienceType: 'hologram',
    hologramType: 'projection',
    title: 'Castel Oggi - Ologramma',
    description: 'Ologramma interattivo del Castel Oggi con proiezioni 3D.',
    projectionSurface: 'cylindrical',
    interactiveElements: ['rotate', 'zoom', 'info'],
    customParams: {
      brightness: '80%',
      colorTemperature: '6500K',
      ambientLight: true
    }
  },

  hologramBunker: {
    experienceType: 'hologram',
    hologramType: 'floating',
    title: 'Bunker - Ologramma Fluttuante',
    description: 'Ologramma fluttuante del bunker con effetti speciali.',
    projectionSurface: 'air',
    interactiveElements: ['explode', 'reconstruct', 'timeline'],
    customParams: {
      particleEffects: true,
      soundEnabled: true,
      depth: '2m'
    }
  },

  // Template per nuovi ologrammi
  createHologram: (hologramName, options = {}) => ({
    experienceType: 'hologram',
    hologramType: options.hologramType || 'projection',
    title: options.title || hologramName,
    description: options.description || `Ologramma di ${hologramName}`,
    projectionSurface: options.projectionSurface || 'flat',
    interactiveElements: options.interactiveElements || ['rotate'],
    customParams: {
      brightness: options.brightness || '100%',
      colorTemperature: options.colorTemperature || '6500K',
      ...options.customParams
    }
  }),

  // Esperienza ologramma di Filippo Nicolai
  filippoNicolaiHologram: {
    experienceType: 'ar',
    modelType: 'filippoNicolaiHologram',
    title: 'Filippo Nicolai - Ologramma AR',
    description: 'Esperienza ologramma AR con image target per il quadro di Filippo Nicolai',
    customParams: {
      targetName: 'filippo-nicolai-quadro',
      videoName: 'filippoNicolai',
      videoPath: 'https://iscag-ei.it/wp-content/materiale/immaginianimate/filippo-nicolai-video.mp4',
      cameraPosition: '0 4 10',
      lightIntensity: '1',
      hologramType: 'video-fade'
    }
  },

  // Esperienza AR di Mario Fiore
  marioFioreAR: {
    experienceType: 'ar',
    modelType: 'marioFioreAR',
    title: 'Mario Fiore - Esperienza AR',
    description: 'Esperienza AR con image target per Mario Fiore',
    customParams: {
      targetName: 'mario-fiore',
      videoName: 'video-mario-fiore',
      videoPath: 'https://iscag-ei.it/wp-content/materiale/immaginianimate/video-mario-fiore.mp4',
      cameraPosition: '0 4 10',
      lightIntensity: '1',
      arType: 'video-fade'
    }
  }
}

// Funzione principale estesa per supportare diverse tipologie di esperienze
export const navigateToExperience = (history, location, config) => {
  const {
    experienceType = '3d', // nuovo parametro per distinguere il tipo
    modelType = 'generic',
    modelPath,
    scale = '1 1 1',
    position = '0 0 0',
    rotation = '0 0 0',
    title,
    description,
    envmap,
    animation = 'no',
    repeat = 'no',
    listAnim = ['Scene'],
    text = 'Animazione',
    customParams = {},
    // Parametri specifici per ologrammi
    hologramType,
    projectionSurface,
    interactiveElements,
    // Parametri per video immersivi
    videoUrl,
    audioUrl,
    // Parametri per AR
    arFeatures,
    trackingType
  } = config

  // Prepara i parametri personalizzati in base al tipo di esperienza
  let finalCustomParams = {
    experienceType,
    title,
    description,
    ...customParams
  }

  // Configurazione specifica per tipo di esperienza
  if (experienceType === '3d') {
    finalCustomParams = {
      ...finalCustomParams,
      modelPath: modelPath || getModelPath(modelType),
      scale,
      position,
      rotation,
      animation,
      repeat,
      listAnim: JSON.stringify(listAnim),
      text
    }
  } else if (experienceType === 'hologram') {
    finalCustomParams = {
      ...finalCustomParams,
      hologramType,
      projectionSurface,
      interactiveElements: JSON.stringify(interactiveElements)
    }
  } else if (experienceType === 'video') {
    finalCustomParams = {
      ...finalCustomParams,
      videoUrl,
      audioUrl
    }
  } else if (experienceType === 'ar') {
    finalCustomParams = {
      ...finalCustomParams,
      arFeatures: JSON.stringify(arFeatures),
      trackingType
    }
  }

  // Aggiungi envmap se specificato (comune a tutte le tipologie)
  if (envmap && Array.isArray(envmap)) {
    finalCustomParams.envmap = JSON.stringify(envmap)
  }

  // Usa sempre 3d-experience ma con parametri diversi per gestire tutti i tipi
  const routeName = '3d-experience'
  
  // Naviga verso l'esperienza appropriata
  history.push(path(location, routeName), {
    experienceType,
    customParams: finalCustomParams,
    showScene: true,
    title,
    description
  })
}

// Nuove funzioni per recuperare esperienze da WordPress
export const getAllExperiencesFromWordPress = async () => {
  try {
    console.log('🔄 Caricamento esperienze da WordPress...')
    const wpExperiences = await wordpressAPI.getAllExperiences()
    
    if (wpExperiences && wpExperiences.length > 0) {
      console.log(`✅ Caricate ${wpExperiences.length} esperienze da WordPress`)
      const convertedExperiences = wpExperiences.map(exp => wordpressAPI.convertToAppFormat(exp))
      console.log('🔄 Esperienze convertite nel formato dell\'app:', convertedExperiences.length)
      return convertedExperiences
    } else {
      console.warn('⚠️ Nessuna esperienza trovata in WordPress, uso fallback')
      return Object.values(experienceConfigs)
    }
  } catch (error) {
    console.error('❌ Errore nel recupero esperienze da WordPress:', error)
    // Fallback alle esperienze hardcoded
    console.log('🔄 Fallback alle esperienze hardcoded...')
    return Object.values(experienceConfigs)
  }
}

export const getExperiencesByTypeFromWordPress = async (type) => {
  try {
    console.log(`🔄 Caricamento esperienze ${type} da WordPress...`)
    const wpExperiences = await wordpressAPI.getExperiencesByType(type)
    
    if (wpExperiences && wpExperiences.length > 0) {
      console.log(`✅ Caricate ${wpExperiences.length} esperienze ${type} da WordPress`)
      const convertedExperiences = wpExperiences.map(exp => wordpressAPI.convertToAppFormat(exp))
      return convertedExperiences
    } else {
      console.warn(`⚠️ Nessuna esperienza ${type} trovata in WordPress, uso fallback`)
      return Object.values(experienceConfigs).filter(exp => exp.experienceType === type)
    }
  } catch (error) {
    console.error(`❌ Errore nel recupero esperienze ${type} da WordPress:`, error)
    // Fallback alle esperienze hardcoded filtrate per tipo
    console.log(`🔄 Fallback alle esperienze hardcoded filtrate per tipo ${type}...`)
    return Object.values(experienceConfigs).filter(exp => exp.experienceType === type)
  }
}

export const searchExperiencesFromWordPress = async (searchTerm) => {
  try {
    if (!searchTerm.trim()) {
      console.log('🔍 Ricerca vuota, carico tutte le esperienze...')
      return await getAllExperiencesFromWordPress()
    }
    
    console.log(`🔍 Ricerca esperienze per "${searchTerm}" in WordPress...`)
    const wpExperiences = await wordpressAPI.searchExperiences(searchTerm)
    
    if (wpExperiences && wpExperiences.length > 0) {
      console.log(`✅ Trovate ${wpExperiences.length} esperienze per "${searchTerm}"`)
      const convertedExperiences = wpExperiences.map(exp => wordpressAPI.convertToAppFormat(exp))
      return convertedExperiences
    } else {
      console.warn(`⚠️ Nessuna esperienza trovata per "${searchTerm}" in WordPress, uso ricerca locale`)
      // Fallback alla ricerca locale
      const allExperiences = Object.values(experienceConfigs)
      const term = searchTerm.toLowerCase()
      const filtered = allExperiences.filter(exp => 
        exp.title.toLowerCase().includes(term) ||
        (exp.description && exp.description.toLowerCase().includes(term)) ||
        exp.modelType.toLowerCase().includes(term)
      )
      console.log(`🔍 Ricerca locale: trovate ${filtered.length} esperienze`)
      return filtered
    }
  } catch (error) {
    console.error('❌ Errore nella ricerca esperienze da WordPress:', error)
    // Fallback alla ricerca locale
    console.log('🔄 Fallback alla ricerca locale...')
    const allExperiences = Object.values(experienceConfigs)
    if (!searchTerm.trim()) return allExperiences
    
    const term = searchTerm.toLowerCase()
    const filtered = allExperiences.filter(exp => 
      exp.title.toLowerCase().includes(term) ||
      (exp.description && exp.description.toLowerCase().includes(term)) ||
      exp.modelType.toLowerCase().includes(term)
    )
    console.log(`🔍 Ricerca locale: trovate ${filtered.length} esperienze`)
    return filtered
  }
}

export const getExperienceByIdFromWordPress = async (experienceId) => {
  try {
    console.log(`🔄 Caricamento esperienza ${experienceId} da WordPress...`)
    const wpExperience = await wordpressAPI.getExperienceById(experienceId)
    
    if (wpExperience) {
      console.log(`✅ Esperienza ${experienceId} caricata da WordPress`)
      const convertedExperience = wordpressAPI.convertToAppFormat(wpExperience)
      return convertedExperience
    } else {
      console.warn(`⚠️ Esperienza ${experienceId} non trovata in WordPress, uso fallback`)
      // Fallback alle esperienze hardcoded
      return experienceConfigs[experienceId] || null
    }
  } catch (error) {
    console.error(`❌ Errore nel recupero esperienza ${experienceId} da WordPress:`, error)
    // Fallback alle esperienze hardcoded
    console.log(`🔄 Fallback alle esperienze hardcoded per ${experienceId}...`)
    return experienceConfigs[experienceId] || null
  }
}

/**
 * Testa la connessione all'API WordPress
 */
export const testWordPressConnection = async () => {
  try {
    console.log('🧪 Test connessione API WordPress...')
    const isOnline = await wordpressAPI.forceConnectionTest()
    
    if (isOnline) {
      console.log('✅ API WordPress connessa e funzionante')
      
      // Test health check
      const health = await wordpressAPI.healthCheck()
      if (health) {
        console.log('🏥 Health check:', health)
      }
      
      return true
    } else {
      console.warn('⚠️ API WordPress non disponibile')
      return false
    }
  } catch (error) {
    console.error('❌ Errore nel test connessione:', error)
    return false
  }
}

/**
 * Esegue diagnostica completa dell'API
 */
export const runWordPressDiagnostics = async () => {
  try {
    console.log('🔍 Avvio diagnostica completa...')
    const diagnostics = await wordpressAPI.runDiagnostics()
    
    console.log('📊 Diagnostica completata:', diagnostics)
    
    // Mostra risultati in console
    if (diagnostics.isOnline) {
      console.log('✅ API WordPress funzionante')
      console.log('🔗 URL:', diagnostics.baseUrl)
    } else {
      console.log('❌ API WordPress non disponibile')
      console.log('🔗 URL tentato:', diagnostics.baseUrl)
      console.log('🌐 Origin corrente:', diagnostics.currentOrigin)
      if (diagnostics.lastError) {
        console.log('🚨 Ultimo errore:', diagnostics.lastError)
      }
    }
    
    return diagnostics
  } catch (error) {
    console.error('❌ Errore durante diagnostica:', error)
    return null
  }
}

/**
 * Ottiene lo stato di connessione dell'API
 */
export const getWordPressConnectionStatus = () => {
  return wordpressAPI.getConnectionStatus()
}

/**
 * Pulisce la cache dell'API WordPress
 */
export const clearWordPressCache = () => {
  wordpressAPI.clearCache()
  console.log('🧹 Cache WordPress pulita')
} 